"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var withStyles_1 = require("@material-ui/styles/withStyles");
var react_router_dom_1 = require("react-router-dom");
var UserCart_1 = require("src/bookstore/UserCart/UserCart");
var CurrentUser_1 = require("src/CurrentUser");
var CurrentUserDropdownMenu_1 = require("./CurrentUserDropdownMenu");
var SiteHeaderLink_1 = require("./SiteHeaderLink");
var styles_1 = require("./styles");
/**
 * Render site header, highlight current page based on router state
 * Hide links with no current user: logout, library
 * Hide links when there is a current user: login, signUp
 */
var SiteHeader = /** @class */ (function (_super) {
    __extends(SiteHeader, _super);
    function SiteHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteHeader.prototype.render = function () {
        var _a = this.props, classes = _a.classes, location = _a.location, userCart = _a.userCart;
        var headerContainer = classes.headerContainer, headerContentWrapper = classes.headerContentWrapper, leftRightContainers = classes.leftRightContainers;
        var cartItemCount = userCart && userCart.cartData &&
            userCart.cartData.lineItems && userCart.cartData.lineItems.length || 0;
        return (React.createElement(CurrentUser_1.CurrentUserConsumer, null, function (currentUser) {
            var userLoading = currentUser.loading, loggedInUser = currentUser.loggedInUser;
            return (React.createElement(Grid_1.default, { container: true, className: headerContainer },
                React.createElement(Grid_1.default, { container: true, className: headerContentWrapper },
                    React.createElement(Grid_1.default, { container: true, className: leftRightContainers },
                        !userLoading && loggedInUser === null && (React.createElement(React.Fragment, null,
                            React.createElement(SiteHeaderLink_1.default, { currentPath: location.pathname, linkPath: "/login/" }, "Login"),
                            React.createElement(SiteHeaderLink_1.default, { currentPath: location.pathname, linkPath: "/signUp/" }, "Signup"))),
                        !userLoading && loggedInUser !== null &&
                            React.createElement(CurrentUserDropdownMenu_1.default, { currentUser: loggedInUser })),
                    React.createElement(Grid_1.default, { container: true, className: leftRightContainers },
                        React.createElement(SiteHeaderLink_1.default, { isIndex: !userLoading && loggedInUser !== null, currentPath: location.pathname, linkPath: "/library/" }, "Library"),
                        React.createElement(SiteHeaderLink_1.default, { isIndex: !userLoading && loggedInUser === null, currentPath: location.pathname, linkPath: "/products/", matchPrefix: true }, "Shop"),
                        React.createElement(SiteHeaderLink_1.default, { currentPath: location.pathname, linkPath: "/cart/", matchPrefix: true },
                            "Cart",
                            cartItemCount > 0 ? " (" + cartItemCount + ")" : '')))));
        }));
    };
    return SiteHeader;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(react_router_dom_1.withRouter(UserCart_1.withUserCart(SiteHeader)));
